import { Component, Input } from '@angular/core';
import { VersionHistoryChangesPanelComponent } from '@components/version-history-changes-panel/version-history-changes-panel.component';
import { COLOR_OPTIONS } from 'icreate/common/models/version-change-panel';

@Component({
    selector: 'app-owner-changes-panel',
    templateUrl: './owner-changes-panel.component.html',
    styleUrls: [
        './owner-changes-panel.component.css',
        '../version-history-changes-panel/version-history-changes-panel.component.css',
    ],
    standalone: false,
})
export class OwnerChangesPanelComponent extends VersionHistoryChangesPanelComponent {
    @Input() owner: string;
    @Input() editors: string[];
    @Input() version: string;

    ngOnInit(): void {
        if (this.owner) {
            this.colors[this.owner] = COLOR_OPTIONS[0];
            for (let i = 0; i < this.editors?.length; i++) {
                if (i + 1 < COLOR_OPTIONS.length) {
                    this.colors[this.editors[i]] = COLOR_OPTIONS[i + 1];
                } else {
                    this.colors[this.editors[i]] = COLOR_OPTIONS[i - COLOR_OPTIONS.length + 1];
                }
            }
        }
    }
}
